import { render, staticRenderFns } from "./DataPoint.vue?vue&type=template&id=9150f3d2&"
import script from "./DataPoint.vue?vue&type=script&lang=js&"
export * from "./DataPoint.vue?vue&type=script&lang=js&"
import style0 from "./DataPoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports